import Button from 'antd/lib/button';
import message from 'antd/lib/message';
import Popconfirm from 'antd/lib/popconfirm';
import Tooltip from 'antd/lib/tooltip';
import React, { useContext, useEffect, useState } from 'react';
import { axiosDeleteCall, axiosGetCall } from '../api/axiosCall';
import CommonLayout from '../common/CommonLayout';
import DataTable from '../common/DataTable';
import { getColumnSearchProps } from '../common/DataTableSearchTemplate';
import { API_END_POINT, SOMETHING_WENT_WRONG } from '../constant/constants';
import { AuthContext } from '../context/AuthProvider';
import AddSparePart from './SparePart/AddSparePart';
import EditSparePart from './SparePart/EditSparePart';
import ViewSparePart from './SparePart/ViewSparePart';
import PlusOutlined from '@ant-design/icons/PlusOutlined';
import EyeOutlined from '@ant-design/icons/EyeOutlined';
import EditOutlined from '@ant-design/icons/EditOutlined';
import DeleteOutlined from '@ant-design/icons/DeleteOutlined';

const TableHeader = ({ handleAddButtonClick }) => {
  return (
    <div className='flex-row justify-end flex'>
      <Button
        type='primary'
        icon={<PlusOutlined />}
        className='border-none bg-gradient-to-r from-blue-500 to-purple-600 shadow hover:shadow-md'
        onClick={handleAddButtonClick}
      >
        Add Spare Part
      </Button>
    </div>
  );
};

function SparePart() {
  const [sparePartList, setSparePartList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModelOpen, setIsViewModelOpen] = useState(false);
  const [isEditModelOpen, setIsEditModelOpen] = useState(false);
  const [sparePart, setSparePart] = useState('');

  const { token } = useContext(AuthContext);

  useEffect(() => {
    getAllSparePart();
  }, []);

  async function getAllSparePart() {
    try {
      const res = await axiosGetCall({
        apiEndPoint: API_END_POINT.GET_SPARE_PART,
        header: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.hideErrorFromUser) {
        setSparePartList(res.data);
        if (sparePart) {
          res.data.forEach((item) => {
            if (item.productId === sparePart.productId) {
              setSparePart(item);
            }
          });
        }
      } else {
        message.error(SOMETHING_WENT_WRONG);
      }
      setIsLoading(false);
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
    }
  }

  function handleAddButtonClick() {
    setIsModalOpen(!isModalOpen);
  }

  function handleAddModelClose() {
    setIsModalOpen(false);
  }

  function handleViewButtonClick(data) {
    setIsViewModelOpen(true);
    setSparePart(data);
  }

  function handleViewModelCloseClick() {
    setIsViewModelOpen(false);
  }

  function handleEditButtonClick(data) {
    setIsEditModelOpen(true);
    setSparePart(data);
  }

  function handleEditModelCloseClick() {
    setIsEditModelOpen(false);
  }

  async function handleDeleteProduct(record) {
    try {
      const res = await axiosDeleteCall({
        apiEndPoint: `${API_END_POINT.DELETE_SPARE_PART}?SparePartId=${record.sparePartId}`,
        header: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.hideErrorFromUser) {
        message.success(res.data);
        getAllSparePart();
      } else {
        message.error(res.error.message);
      }
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
    }
  }

  const columns = [
    {
      title: 'Image',
      render: (record) => {
        return (
          <div className='h-20 w-20'>
            <img
              src={record.productImage}
              alt={`product_image`}
              className='w-20 h-20 object-contain'
            />
          </div>
        );
      },
    },
    {
      key: 'sparePartName',
      title: 'Spare Part Name',
      dataIndex: 'sparePartName',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => {
        if (a.sparePartName)
          return a.sparePartName.localeCompare(b.sparePartName);
      },
      ...getColumnSearchProps('sparePartName'),
    },
    {
      key: 'modelNo',
      title: 'Parts Number',
      dataIndex: 'modelNo',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => {
        if (a.modelNo) return a.modelNo.localeCompare(b.modelNo);
      },
      ...getColumnSearchProps('modelNo'),
    },
    {
      key: 'price',
      title: 'Prices',
      dataIndex: 'price',
      render: (e, record) => {
        return (
          <div className='flex flex-col'>
            <span>P1: {record.p1}</span>
            <span>P2: {record.p2}</span>
            <span>P3: {record.p3}</span>
            <span>R1: {record.r1}</span>
          </div>
        );
      },
    },
    {
      title: 'Product Name',
      render: (record) => {
        return (
          <div className='flex flex-col text-ellipsis h-10 overflow-hidden'>
            <Tooltip
              title={() => {
                return (
                  <div className='flex flex-col text-ellipsis h-10 overflow-hidden'>
                    {record?.productNames?.map((item) => (
                      <p key={item}>{item}</p>
                    ))}
                  </div>
                );
              }}
              destroyTooltipOnHide
              overlayStyle={{
                minWidth: '500px',
              }}
              color='white'
              overlayInnerStyle={{ color: 'black' }}
            >
              {record?.productNames?.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: 'Actions',
      render: (e, record) => (
        <div className='flex flex-col items-center gap-2'>
          <Button
            onClick={() => {
              handleViewButtonClick(record);
            }}
            className='border-primary text-primary'
            icon={<EyeOutlined />}
          >
            View
          </Button>
          <Button
            onClick={() => {
              handleEditButtonClick(record);
            }}
            type='primary'
            className='border-none bg-gradient-to-r from-blue-500 to-purple-600 shadow hover:shadow-md'
            icon={<EditOutlined />}
          >
            Edit
          </Button>
          <Popconfirm
            title='Are you Sure to Delete?'
            onConfirm={() => handleDeleteProduct(record)}
            okType='default'
          >
            <Button
              danger
              icon={<DeleteOutlined />}
            >
              Delete
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <CommonLayout>
      <div className='flex flex-col items-stretch'>
        <DataTable
          title={<TableHeader handleAddButtonClick={handleAddButtonClick} />}
          isTableRowEditable={false}
          data={sparePartList}
          columns={columns}
          isSpinning={isLoading}
          rowKey='sparePartId'
        />
        <ViewSparePart
          isOpen={isViewModelOpen}
          sparePart={sparePart}
          handleViewModelCloseClick={handleViewModelCloseClick}
        />
        <AddSparePart
          isOpen={isModalOpen}
          callback={getAllSparePart}
          handleAddModelClose={handleAddModelClose}
        />
        {isEditModelOpen && (
          <EditSparePart
            isOpen={isEditModelOpen}
            product={sparePart}
            callback={getAllSparePart}
            handleEditModelCloseClick={handleEditModelCloseClick}
          />
        )}
      </div>
    </CommonLayout>
  );
}

export default SparePart;
